import { keyBy, reject } from 'lodash';
import { contractsConstants } from '../constants/contracts';

const initialState = {
  self: {},
  ip: {},
  ooo: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case contractsConstants.GET_CONTRACTS_SUCCESS:
      return {
        ...state,
        [action.contractType]: keyBy(action.items, 'id'),
      };
      case contractsConstants.CHANGE_CONTRACT_SUCCESS:
        return {
          ...state,
          [action.contractType]: {
            ...state[action.contractType],
            [action.item.id]: action.item
          },
        };
      case contractsConstants.DELETE_CONTRACT_SUCCESS:
        return {
          ...state,
          [action.contractType]: keyBy(reject(state[action.contractType], (value, key) => value.id === action.id), 'id'),
        };
    default:
      return state;
  }
};
